import * as React from 'react'
import Button from 'common/components/Button'
import styled from 'styled-components/macro'
import {CaretDown, CaretUp} from 'phosphor-react'
import SpeedDropDownCard from './SpeedDropDownCard'
const Wrapper = styled.div`
  position: relative;
  width: auto;
  display: flex;
`
const StyledButton = styled(Button)`
  margin-left: 5px;
  background: transparent;
  color: var(--primary);
  font-weight: bold;
  display: flex;
  flex-direction: row;
  padding: 0px;
  align-items: center;

  svg {
    margin-right: 5px;
  }
  :hover {
    background: transparent;
    color: var(--secondary);
  }
`
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 8px 10px;
  min-width: 104px;
  background: ${(props: {active: boolean}) =>
    props.active ? 'var(--asc-selectedgreen)' : 'transparent'};
  cursor: pointer;
  border: ${props =>
    props.active ? '1px solid var(--primary)' : '1px solid transparent'};
  :hover {
    background: var(--asc-selectedgreen);
    border: 1px solid var(--primary);
    span {
      color: var(--primary);
      svg {
        color: var(--primary);
      }
    }
  }
`
const Text = styled.span`
  display: flex;
  flex-direction: row;
  font-size: 16px;
  font-weight: 600;
  color: var(--primary);
  align-items: center;
  span {
    margin-right: 5px;
  }
  svg {
    color: var(--primary);
    margin-right: 0px;
  }
`
const IconHolder = styled.div`
  display: flex;
  width: 12px;
  height: 12px;
  align-items: center;
  justify-content: center;
`
/**
 * A dropdown component for selecting a speed.
 * @param {SpeedDropDownProps} props - The component props.
 * @param {SpeedOption[]} props.options - The list of speed options.
 * @param {(speed: string) => void} props.onChange - The function to call when the speed changes.
 * @param {string} props.speed - The current speed.
 * @returns {JSX.Element} The SpeedDropDown component.
 */
const SpeedDropDown = ({
  options,
  onChange,
  speed,
}: SpeedDropDownProps): JSX.Element => {
  const [open, setOpen] = React.useState<boolean>(false)
  const drop = React.useRef<HTMLDivElement | null>(null)

  return (
    <Wrapper className="dropdown" ref={drop} onClick={() => setOpen(!open)}>
      <StyledButton active={open} onClick={() => null}>
        <Container active={open}>
          <Text>
            <span>
              {`${
                options.find((element: OptionType) => element.value === speed)!
                  .key
              }`}
            </span>
            <IconHolder>
              {open ? (
                <CaretUp
                  size={14}
                  weight="fill"
                  onClick={() => {
                    setOpen(false)
                  }}
                />
              ) : (
                <CaretDown
                  size={14}
                  weight="fill"
                  onClick={() => {
                    setOpen(true)
                  }}
                />
              )}
            </IconHolder>
          </Text>
        </Container>
      </StyledButton>
      {open && (
        <SpeedDropDownCard
          options={options}
          setOpen={setOpen}
          onChange={onChange}
          speed={speed}
        />
      )}
    </Wrapper>
  )
}

interface SpeedDropDownProps {
  options: OptionType[]
  onChange: (speed: string) => void
  speed: number
}

export interface OptionType {
  key: string
  value: string | number
  text: string
}

export default SpeedDropDown
